import { render, staticRenderFns } from "./SelectTermsCondition.vue?vue&type=template&id=770f86c4&"
import script from "./SelectTermsCondition.vue?vue&type=script&lang=js&"
export * from "./SelectTermsCondition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports